<div class="c-premiumPass__start">
  <div
    class="e-background"
    theming
    themingGroup="premiumpass"
    themingAsset="start-background"
    [themingOverride]="event?.assets">
    <slotcom-navigation-button
      type="close"
      topPosition="0"
      rightPosition="0"
      (click)="closeModal()">
    </slotcom-navigation-button>

    <div class="e-timer">
      <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
      <slotcom-animated-timer
        [showInDays]="true"
        [endDate]="premiumPassStartModalData.expirationDate"
        (expired)="closeModal()"></slotcom-animated-timer>
    </div>

    <slotcom-button
      class="c-button--pink"
      (safeClick)="openOffer()">
      {{ buttonText | uppercase }}
    </slotcom-button>
  </div>
</div>
